import { takeEvery, put, select } from 'redux-saga/effects'

import {
  postReviewsUserReminderBulk,
  getReviewsUsers,
  postReviewsUserReviewers,
  postReviewsUserReminder,
} from '../actions'
import { getOrganizationsUsersOrganization } from 'store/entities/organizations/selectors'

export function* handlePostReviewsUserReminderBulkSuccess() {
  const organization = yield select(getOrganizationsUsersOrganization)
  yield put(getReviewsUsers(organization.get('id')))
}

export default function* postReviewsUserReminderBulkSuccess() {
  yield takeEvery(
    [
      postReviewsUserReminderBulk.success.toString(),
      postReviewsUserReviewers.success.toString(),
      postReviewsUserReminder.success.toString(),
    ],
    handlePostReviewsUserReminderBulkSuccess
  )
}
